'use client';

import React, { useState, useEffect } from 'react';

interface CountdownProps {
  targetDate?: string; // Optional targetDate
}

const FlashSaleCountdown: React.FC<CountdownProps> = ({ targetDate }) => {
  // If no targetDate is provided, set it to 2 days from now
  const finalTargetDate = targetDate
    ? new Date(targetDate)
    : new Date(Date.now() + 2 * 24 * 60 * 60 * 1000);

  const calculateTimeLeft = (): {
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
  } => {
    const difference = finalTargetDate.getTime() - new Date().getTime();

    if (difference <= 0) {
      return { days: '00', hours: '00', minutes: '00', seconds: '00' };
    }

    return {
      days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(
        2,
        '0'
      ),
      hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(
        2,
        '0'
      ),
      minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(
        2,
        '0'
      ),
      seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, '0'),
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [targetDate]);

  return (
    <div className="countdown countdown--style2">
      <div className="countdown__block">
        <span className="countdown__number">{timeLeft.days}</span>
        <span className="countdown__label">Days</span>
      </div>
      <div className="countdown__block">
        <span className="countdown__number">{timeLeft.hours}</span>
        <span className="countdown__label">Hours</span>
      </div>
      <div className="countdown__block">
        <span className="countdown__number">{timeLeft.minutes}</span>
        <span className="countdown__label">Mins</span>
      </div>
      <div className="countdown__block">
        <span className="countdown__number">{timeLeft.seconds}</span>
        <span className="countdown__label">Secs</span>
      </div>
    </div>
  );
};

export default FlashSaleCountdown;
